import { render, staticRenderFns } from "./page_not_found.vue?vue&type=template&id=7a708a92&scoped=true&"
import script from "./page_not_found.vue?vue&type=script&lang=js&"
export * from "./page_not_found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a708a92",
  null
  
)

export default component.exports